<template>
  <v-container grid-list-lg fluid>
    <v-layout wrap>
      <v-flex xs12 class='pa-3'>
        <v-card>
          <v-card-title class='headline font-weight-regular oem-color'>
            Alarm Configuration
            <v-spacer/>
            <v-btn
              v-if='storeState.data.alarms.length > 0'
              class='oem-color ma-0'
              @click='clearAllAlarms()'
              flat
              small
            >
              <v-icon>delete_sweep</v-icon>
               Clear All Alarms
            </v-btn>
            <v-btn
              class='oem-color ma-0'
              @click='updateOptions()
                      checkPendingMappingChanges()'
              flat
              small
            >
              <v-icon>playlist_add</v-icon>
              Add Alarm
            </v-btn>
            <v-btn
              flat
              class='transparent ma-0'
              @click='showAlarmHelp = true'
              icon
              small
            >
              <v-icon class='white--text oem-color'>
                help_outline
              </v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <div>
              <v-data-table
                :headers='headers'
                :items='storeState.data.alarms'
                must-sort
                hide-actions=''
              >
                <template v-slot:items='props'>
                  <td>{{ props.item.id + 1 }}</td>
                  <td>{{ storeState.alarmTypes.find(t => t.value === props.item.type).text }}</td>
                  <td>{{ getvinLineLoadOrCtText(props.item) }}</td>
                  <td>{{ storeState.alarmTypes.find(t => t.value === props.item.type).setPointApplicable ?
                         props.item.setPoint + ' ' +
                         storeState.alarmTypes.find(t => t.value === props.item.type).unit :
                         '#NA'}}
                  </td>
                  <td>{{ storeState.alarmTypes.find(t => t.value === props.item.type).deadbandUnit !== '' ?
                           props.item.deadband + ' ' +
                           storeState.alarmTypes.find(t => t.value === props.item.type).deadbandUnit :
                           '#NA'}}
                   </td>
                  <td>{{ storeState.alarmTypes.find(t => t.value === props.item.type).delayApplicable ?
                           props.item.delay :
                           '#NA'}}
                  </td>
                  <td>
                    <v-checkbox
                      :input-value='props.item.led'
                      primary
                      hide-details
                      :disabled="true"
                      class='oem-text-color disabledCheckbox'
                    ></v-checkbox>
                  </td>
                  <td>
                    <v-checkbox
                      :input-value='props.item.relay'
                      primary
                      hide-details
                      :disabled="true"
                      class='oem-text-color disabledCheckbox'
                    ></v-checkbox>
                  </td>
                  <td>
                    <v-icon small class='mr-2' @click='editItem(props.item)'>
                      edit
                    </v-icon>
                    <v-icon small @click='deleteItem(props.item)'>
                      delete
                    </v-icon>
                  </td>
                </template>
              </v-data-table>
              <v-dialog v-model='dialog' persistent max-width='600px'>
                <v-card>
                  <v-card-title class='headline font-weight-regular oem-color'
                    >{{ formTitle }}
                  </v-card-title>

                  <v-card-text>
                    <v-form ref='form' v-model='valid' lazy-validation>
                      <v-container grid-list-md>
                        <v-layout wrap>
                          <v-flex xs12 sm6 md6>
                            <v-select
                              v-model.number='editedItem.type'
                              :items='storeState.alarmTypes'
                              label='Alarm Type'
                              item-value='value'
                              @change='alarmType = storeState.alarmTypes.find(t => t.value === editedItem.type)
                                       editedItem.unit = alarmType.unit;
                                       editedItem.deadbandUnit = alarmType.deadbandUnit
                                       editedItem.setPointApplicable = alarmType.setPointApplicable
                                       editedItem.delayApplicable = alarmType.delayApplicable
                                       editedItem.vinApplicable = alarmType.vinApplicable
                                       editedItem.lineApplicable = alarmType.lineApplicable
                                       editedItem.loadApplicable = alarmType.loadApplicable
                                       editedItem.ctApplicable = alarmType.ctApplicable
                                       editedItem.vinLineLoadOrCt = -1
                                       editedItem.setPoint = alarmType.defaultSetPoint
                                       editedItem.deadband = alarmType.defaultDeadband
                                       editedItem.delay = alarmType.defaultDelay
                                       validate()'
                            ></v-select>
                          </v-flex>
                          <v-flex xs12 sm6 md6>
                            <v-select v-show="editedItem.vinApplicable"
                              v-model.number='editedItem.vinLineLoadOrCt'
                              :items='vinOptions'
                              item-text='text'
                              item-value='id'
                              label='Vin'
                              :rules='vinRules'
                              @change='validate()'
                              @visible-change='validate()'
                            ></v-select>
                            <v-select v-show="editedItem.lineApplicable"
                              v-model.number='editedItem.vinLineLoadOrCt'
                              :items='lineOptions'
                              item-text='text'
                              item-value='id'
                              label='Line'
                              :rules='lineRules'
                              @change='validate()'
                              @visible-change='validate()'
                            ></v-select>
                            <v-select v-show="editedItem.loadApplicable"
                              v-model.number='editedItem.vinLineLoadOrCt'
                              :items='loadOptions'
                              item-text='text'
                              item-value='id'
                              label='Load'
                              :rules='loadRules'
                              @change='validate()'
                              @visible-change='validate()'
                            ></v-select>
                            <v-select v-show="editedItem.ctApplicable"
                              v-model.number='editedItem.vinLineLoadOrCt'
                              :items='ctOptions'
                              item-text='text'
                              item-value='id'
                              label='CT'
                              :rules='ctRules'
                              @change='validate()'
                              @visible-change='validate()'
                            ></v-select>
                            <v-text-field v-show="!editedItem.vinApplicable &&
                                                  !editedItem.lineApplicable &&
                                                  !editedItem.loadApplicable &&
                                                  !editedItem.ctApplicable"
                              label='Vin / Line/ Load / CT'
                              value='Not applicable'
                              class='oem-text-color notApplicable'
                              :disabled="true"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs11 sm3 md3>
                            <v-text-field v-show="editedItem.setPointApplicable"
                              v-model.number='editedItem.setPoint'
                              label='Alarm Set Point'
                              :rules='setPointRules'
                              class='oem-text-color'
                              @change='validate()'
                            ></v-text-field>
                            <v-text-field v-show="!editedItem.setPointApplicable"
                              label='Alarm Set Point'
                              value='Not applicable'
                              class='oem-text-color notApplicable'
                              :disabled="true"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs1 sm1 md1>
                            <v-text-field v-show="editedItem.setPointApplicable"
                              v-model='editedItem.unit'
                              :disabled="true"
                              class='oem-text-color textFieldAsLabel'
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs11 sm3 md3>
                            <v-text-field v-show="editedItem.deadbandUnit!==''"
                              v-model.number='editedItem.deadband'
                              label='Deadband'
                              :rules='deadbandRules'
                              class='oem-text-color'
                              @change='validate()'
                            ></v-text-field>
                            <v-text-field v-show="editedItem.deadbandUnit===''"
                              label='Deadband'
                              value='Not applicable'
                              data-vv-name='Deadband'
                              class='oem-text-color notApplicable'
                              :disabled="true"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs1 sm1 md1>
                            <v-text-field
                              v-model='editedItem.deadbandUnit'
                              :disabled="true"
                              class='oem-text-color textFieldAsLabel'
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm4 md4>
                            <v-text-field v-show="editedItem.delayApplicable"
                              v-model.number='editedItem.delay'
                              mask='###'
                              v-validate="'numeric|min_value:0|max_value:120'"
                              label='Delay Seconds'
                              data-vv-name='Delay Seconds'
                              :error-messages="errors.collect('Delay Seconds')"
                              class='oem-text-color'
                              @change='validate()'
                            ></v-text-field>
                            <v-text-field v-show="!editedItem.delayApplicable"
                              label='Delay Seconds'
                              value='Not applicable'
                              data-vv-name='Delay Seconds'
                              class='oem-text-color notApplicable'
                              :disabled="true"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6 sm6 md6>
                            <v-checkbox
                              v-model='editedItem.led'
                              class='oem-text-color'
                              label='LED Indication'
                              @change='validate()'
                            ></v-checkbox>
                          </v-flex>
                          <v-flex xs6 sm6 md6>
                            <v-checkbox
                              v-model='editedItem.relay'
                              class='oem-text-color'
                              label='Relay Trigger'
                              @change='validate()'
                            ></v-checkbox>
                          </v-flex>
                          <v-flex xs12 sm12 md12 style="white-space: pre-wrap;">{{ editedItem.type == -1 ? '' : descriptionFormatter(storeState.alarmTypes.find(t => t.value === this.editedItem.type).description, editedItem.deadband === 0 ? '' : storeState.alarmTypes.find(t => t.value === this.editedItem.type).descriptionWarning) }}</v-flex>
                          <v-flex xs12 sm12 md12 style="white-space: pre-wrap; font-style: italic;">{{editedItem.type == -1 ? '' : storeState.alarmTypes.find(t => t.value === this.editedItem.type).overlapNote}}</v-flex>
                        </v-layout>
                      </v-container>
                    </v-form>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class='oem-button' flat @click='close'>Cancel</v-btn>
                    <v-btn
                      class='oem-button'
                      flat
                      @click='save'
                      :disabled='!valid'
                    >
                      Save
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <msgDialog
                ref='deleteDialog'
                v-bind:title='`Confirm`'
                v-bind:msg='deleteText'
              />
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  <v-dialog v-model='alarmConfigErrorDialog' max-width='500px'>
    <v-card>
      <v-card-title class='headline font-weight-regular oem-color'
        >Phase Loss Alarm
      </v-card-title>
      <v-card-text>
        Phase loss alarm type can be added only for 3-phase services.
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class='oem-button' flat @click='alarmConfigErrorDialog=false'>Ok</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog v-model='showAlarmHelp' max-width='800px'>
    <v-card>
      <v-card-title class='headline font-weight-regular oem-color'>
        Alarm Help
      </v-card-title>
      <v-card-text>
        Alarms can be configured to trigger a Relay, show a warning LED and create warning logs for undesirable conditions. An alarm has up to 7 properties that can be configured:<br/>
        <ol>
          <li>
            <b>Type</b><br/>
            The type of the error to look out for. There are {{ storeState.alarmTypes.length }} types that can be configured, namely: {{ storeState.alarmTypes.slice(0, storeState.alarmTypes.length - 1).map(a => `'${a.text}'`).join(', ') + ' and \'' + storeState.alarmTypes[storeState.alarmTypes.length - 1].text + '\'' }}.
          </li>
          <li>
            <b>Vin / Line / Load / CT</b><br/>
            Depending on the alarm type you can configure either a Voltage input (Vin), Line, Load or CT.
          </li>
          <li>
            <b>Alarm Set Point</b><br/>
            At what value the alarm should be triggered.
          </li>
          <li>
            <b>Deadband</b><br/>
            In what range an alarm-warning should be logged even though the alarm has not yet been triggered. For example when configuring 'Over Power' on a load with a Set Point of 1000kW the alarm will be triggered when the load uses 1000kW. When a Deadband of 50kW is configured a warning will be logged when the load uses 950kW. A warning will only result in a log entry and will never trigger the LED or Relay.
          </li>
          <li>
            <b>Delay Seconds</b><br/>
            How long the error-condition should exist before the alarm is triggered.
          </li>
          <li>
            <b>LED Indication</b><br/>
            Whether to trigger the LED when the alarm is active.
          </li>
          <li>
            <b>Relay Trigger</b><br/>
            Whether to trigger the Relay when the alarm is active.
          </li>
        </ol>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class='oem-button' flat @click='showAlarmHelp = false'>
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog v-model='updateDialog' persistent max-width='600px'>
    <v-card class="mx-auto">
      <v-card-title class='headline font-weight-regular oem-color'>
        Update Mapping
      </v-card-title>
      <v-card-text>
        <span class='oem-text-color'>
          <div class="d-flex ma-3">
            {{ updateText }}
            <v-spacer></v-spacer>
            <hollow-dots-spinner
              :animation-duration="1000"
              :dot-size="15"
              :dots-num="3"
              color= "var(--primary-color)"
              class="pl-5"
            ></hollow-dots-spinner>
          </div>
        </span>
      </v-card-text>
    </v-card>
  </v-dialog>
  </v-container>
</template>

<script>
import { HollowDotsSpinner } from 'epic-spinners';
import msgDialog from './BaseDialog.vue';
import { EventBus } from '../bus';

export default {
  name: 'Alarm',

  computed: {

    formTitle() {
      return this.editedIndex === -1 ? 'New Alarm' : 'Edit Alarm';
    },

    headers() {
      const list = [
        { text: '#', value: 'id' },
        { text: 'Type', value: 'type' },
        { text: 'Vin / Line / Load / CT', value: 'vinLineLoadOrCt' },
        { text: 'Alarm Set Point', value: 'setPoint' },
        { text: 'Deadband', value: 'deadband' },
        { text: 'Delay Seconds', value: 'delay' },
        { text: 'LED Indication', value: 'led' },
        { text: 'Relay Trigger', value: 'relay' },
        { text: 'Actions', value: 'id', sortable: false },
      ];
      return list;
    },
  },

  components: {
    msgDialog,
    HollowDotsSpinner,
  },

  data() {
    return {
      editedIndex: -1,
      dialog: false,
      showAlarmHelp: false,
      pagination: {
        sortBy: 'id',
      },
      storeState: this.$store.state,
      vinOptions: [],
      lineOptions: [],
      loadOptions: [],
      ctOptions: [],
      errorMsg: [],
      editedItem: {
        vinLineLoadOrCt: -1,
        setPoint: 0,
        deadband: 0,
        delay: 0,
        type: -1,
        led: false,
        relay: false,
        state: 0,

        unit: 'kW',
        deadbandUnit: 'kW',
        setPointApplicable: true,
        delayApplicable: true,
        vinApplicable: false,
        lineApplicable: false,
        loadApplicable: false,
        ctApplicable: false,
      },
      defaultItem: {
        vinLineLoadOrCt: -1,
        setPoint: 0,
        deadband: 0,
        delay: 0,
        type: -1,
        led: false,
        relay: false,
        state: 0,

        unit: 'kW',
        deadbandUnit: 'kW',
        setPointApplicable: true,
        delayApplicable: true,
        vinApplicable: false,
        lineApplicable: false,
        loadApplicable: false,
        ctApplicable: false,
      },
      valid: true,
      alarmConfigErrorDialog: false,
      vinRules: [(v) => {
        if (this.editedItem.vinApplicable) {
          return (v === -1 ? 'Field is required' : true);
        }
        return true;
      }],
      lineRules: [(v) => {
        if (this.editedItem.lineApplicable) {
          return (v === -1 ? 'Field is required' : true);
        }
        return true;
      }],
      loadRules: [(v) => {
        if (this.editedItem.loadApplicable) {
          return (v === -1 ? 'Field is required' : true);
        }
        return true;
      }],
      ctRules: [(v) => {
        if (this.editedItem.ctApplicable) {
          return (v === -1 ? 'Field is required' : true);
        }
        return true;
      }],
      setPointRules: [(v) => {
        if (!!v || v === 0) {
          // value in the range 0-1 with 2 decimals at max
          if (this.editedItem.type !== -1 && this.storeState.alarmTypes.find(t => t.value === this.editedItem.type).floatAsInteger === true) {
            if (typeof v !== 'number') {
              return 'Not a number';
            }
            if (v < 0 || v > 1) {
              return 'Not in range 0-1';
            }

            // console.log((v * 100) % 1);
            if (((v * 100) % 1) > 1e-14 && ((v * 100) % 1) < 0.99999999999999) {
              return 'Only 2 decimals allowed';
            }
          } else if (parseInt(v, 10) !== v) {
            return 'Not an integer';
          }
          if (v < 0) {
            return 'Value must be positive';
          }
          if (this.editedItem.type === 8) { // 8 - Under Voltage
            if (v > 99) {
              return 'Value must be below 100%';
            }
          }

          if (this.editedItem.type === 9) { // 9 - Over voltage
            if (v <= 100) {
              return 'Value must be above 100%';
            }
          }
          return true;
        }
        return 'Field is required';
      }],
      deadbandRules: [(v) => {
        if (!!v || v === 0) {
          if (parseInt(v, 10) === v) {
            if (v < 0) {
              return 'Value must be positive';
            }
            if (v >= this.editedItem.setPoint && this.editedItem.setPointApplicable) {
              return 'Can\'t be greater than or equal to Set Point';
            }
            return true;
          }
          return 'Not an integer';
        }
        return 'Field is required';
      }],
      deleteText: '',
      updateDialog: false,
      updateText: '',
    };
  },

  methods: {
    updateOptions() {
      this.vinOptions = this.$store.state.data.inputs.filter(item => item.active).map(item => ({ id: item.id, text: `Vin ${item.id + 1}` }));
      this.lineOptions = [];
      this.$store.state.data.inputs.filter(item => item.active).forEach((item) => {
        if (item.lines[0].active) {
          this.lineOptions.push({ id: (item.id * 3) + 0, text: `Vin ${item.id + 1} - Line 1` });
        }
        if (item.lines[1].active) {
          this.lineOptions.push({ id: (item.id * 3) + 1, text: `Vin ${item.id + 1} - Line 2` });
        }
        if (item.lines[2].active) {
          this.lineOptions.push({ id: (item.id * 3) + 2, text: `Vin ${item.id + 1} - Line 3` });
        }
      });
      this.loadOptions = this.$store.state.data.loads.map(item => ({ id: item.id, text: `Load ${item.id + 1} - ${item.name}` }));
      this.ctOptions = this.$store.state.data.allCts.filter(item => item.active).map(item => ({ id: item.channel - 6, text: `CT ${item.channel - 5}` }));
    },

    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    unsavedData() {
      let retVal = false;
      if (this.storeState.voltageDirty) {
        retVal = true;
      }
      if (this.storeState.loadDirty) {
        retVal = true;
      }
      if (this.storeState.ctDirty) {
        retVal = true;
      }
      return retVal;
    },
    checkPendingMappingChanges() {
      if (this.unsavedData()) {
        // Start upload dialog here
        this.updateText = 'Uploading Vin / Line / Load / CT changes. Please wait.';
        this.updateDialog = true;
        this.$timer.start('forceMappingComplete');
        // Start force upload
        EventBus.$emit('force-mapping', 'creating-alarms');
      } else {
        this.dialog = true;
      }
    },
    forceMappingComplete() {
      this.$timer.stop('forceMappingComplete');
      this.updateText = '';
      this.updateDialog = false;
      // Close Upload dialog
      this.dialog = true;
    },

    editItem(item) {
      if (this.unsavedData()) {
        // Start upload dialog here
        this.updateText = 'Uploading Vin / Line / Load / CT changes. Please wait.';
        this.updateDialog = true;
        EventBus.$emit('force-mapping', 'creating-alarms');
        setTimeout(() => { this.editItem(item); }, 5000);
        return;
      }
      this.updateText = '';
      this.updateDialog = false;
      this.updateOptions();
      this.editedIndex = this.storeState.data.alarms.indexOf(item);
      this.editedItem = JSON.parse(JSON.stringify(item));
      const alarmType = this.storeState.alarmTypes.find(t => t.value === this.editedItem.type);
      this.editedItem.unit = alarmType.unit;
      this.editedItem.deadbandUnit = alarmType.deadbandUnit;
      this.editedItem.setPointApplicable = alarmType.setPointApplicable;
      this.editedItem.delayApplicable = alarmType.delayApplicable;
      this.editedItem.vinApplicable = alarmType.vinApplicable;
      this.editedItem.lineApplicable = alarmType.lineApplicable;
      this.editedItem.loadApplicable = alarmType.loadApplicable;
      this.editedItem.ctApplicable = alarmType.ctApplicable;

      this.dialog = true;
      this.validate();
    },

    deleteItem(item) {
      this.deleteText = `Are you sure you want to delete alarm ${item.id + 1}`;
      this.$refs.deleteDialog
        .pop()
        .then(() => {
          const index = this.storeState.data.alarms.indexOf(item);
          this.storeState.data.alarms.splice(index, 1);
          for (let i = index; i < this.storeState.data.alarms.length; i += 1) {
            this.storeState.data.alarms[i].id -= 1;
          }
          this.storeState.alarmsDirty = true;
        })
        .catch(() => {});
    },

    clearAllAlarms() {
      this.deleteText = 'Are you sure you want to clear all alarms?';
      this.$refs.deleteDialog
        .pop()
        .then(() => {
          // Slice the whole alarm list - this will remove all the alarm items from the list
          this.storeState.data.alarms.splice(0, this.storeState.data.alarms.length);
          this.storeState.alarmsDirty = true;
        })
        .catch(() => {});
    },

    close() {
      this.dialog = false;
      this.updateDialog = false;
      this.updateText = '';
      setTimeout(() => {
        this.editedItem = JSON.parse(JSON.stringify(this.defaultItem));
        this.editedIndex = -1;
        this.$refs.form.resetValidation();
        this.valid = true;
        this.errorMsg = [];
      }, 300);
    },

    validate() {
      this.$refs.form.validate();
    },

    getServicePhases(service) {
      // eslint-disable-next-line
      let phases = 0;
      if (service === 1
          || service === 2
          || service === 3) {
        phases = 3;
      } else if (service === 4) {
        phases = 2;
      } else if (service === 5) {
        phases = 1;
      }
      return phases;
    },

    save() {
      this.validate();
      if (!this.valid) {
        return;
      }

      // Check that Phase loss alarms can be added only for 3-phase service types
      if (this.editedItem.type === 7 && this.editedItem.loadApplicable) { // 7 - Phase Loss alarm type
        if (this.storeState.data.loads.length > this.editedItem.vinLineLoadOrCt) {
          const inputType = this.storeState.data.loads[this.editedItem.vinLineLoadOrCt].input;
          if (inputType !== undefined) {
            const serviceType = this.storeState.data.inputs[inputType].service;
            if (serviceType !== undefined) {
              if (this.getServicePhases(serviceType) !== 3) {
                this.alarmConfigErrorDialog = true;
                this.close();
                return;
              }
            }
          }
        }
      }

      //  Set overlapping alarms dirty
      if (this.isOverlappingAlarmModified(this.editedItem)) {
        this.storeState.overlappingAlarmsDirty = true;
      }

      // Actual save logic starts here
      if (this.editedIndex > -1) {
        Object.assign(this.storeState.data.alarms[this.editedIndex], this.editedItem);
      } else {
        this.editedItem.id = this.storeState.data.alarms.length;
        delete this.editedItem.unit;
        delete this.editedItem.deadbandUnit;
        delete this.editedItem.setPointApplicable;
        delete this.editedItem.delayApplicable;
        delete this.editedItem.vinApplicable;
        delete this.editedItem.lineApplicable;
        delete this.editedItem.loadApplicable;
        delete this.editedItem.ctApplicable;
        this.storeState.data.alarms.push(this.editedItem);
      }
      this.close();
      this.storeState.alarmsDirty = true;
    },

    isOverlappingAlarmModified(item) {
      let returnVal = false;
      switch (item.type) {
        case 0: // 0-Over power
          // check if any overlapping alarms exists(in this case it is 1-Under power type alarm)
          for (let ai = 0; ai < this.storeState.data.alarms.length; ai += 1) {
            if ((this.storeState.data.alarms[ai].type === 1)
                && (this.storeState.data.alarms[ai].vinLineLoadOrCt === item.vinLineLoadOrCt)) { // 1-Under power
              returnVal = true;
              break;
            }
          }
          break;
        case 1: // 1-Under power
          // check if any overlapping alarms exists(in this case it is 0-Over power type alarm)
          for (let ai = 0; ai < this.storeState.data.alarms.length; ai += 1) {
            if ((this.storeState.data.alarms[ai].type === 0)
                && (this.storeState.data.alarms[ai].vinLineLoadOrCt === item.vinLineLoadOrCt)) { // 0-Over power
              returnVal = true;
              break;
            }
          }
          break;
        case 5: // 5-Under current CT
          // check if any overlapping alarms exists(in this case it is 6-Over current CT type alarm)
          for (let ai = 0; ai < this.storeState.data.alarms.length; ai += 1) {
            if ((this.storeState.data.alarms[ai].type === 6)
                && (this.storeState.data.alarms[ai].vinLineLoadOrCt === item.vinLineLoadOrCt)) { // 6-Over current CT
              returnVal = true;
              break;
            }
          }
          break;
        case 6: // 6-Over current CT
          // check if any overlapping alarms exists(in this case it is 5-Under current CT type alarm)
          for (let ai = 0; ai < this.storeState.data.alarms.length; ai += 1) {
            if ((this.storeState.data.alarms[ai].type === 5)
                && (this.storeState.data.alarms[ai].vinLineLoadOrCt === item.vinLineLoadOrCt)) { // 5-Under current CT
              returnVal = true;
              break;
            }
          }
          break;
        case 8: // 8-Under voltage
          // check if any overlapping alarms exists(in this case it / 9-Over voltage is type alarm)
          for (let ai = 0; ai < this.storeState.data.alarms.length; ai += 1) {
            if ((this.storeState.data.alarms[ai].type === 9)
                && (this.storeState.data.alarms[ai].vinLineLoadOrCt === item.vinLineLoadOrCt)) { // 9-Over voltage
              returnVal = true;
              break;
            }
          }
          break;
        case 9: // 9-Over voltage
          // check if any overlapping alarms exists(in this case it is // 8-Under voltage type alarm)
          for (let ai = 0; ai < this.storeState.data.alarms.length; ai += 1) {
            if ((this.storeState.data.alarms[ai].type === 8)
                && (this.storeState.data.alarms[ai].vinLineLoadOrCt === item.vinLineLoadOrCt)) { // 8-Under voltage
              returnVal = true;
              break;
            }
          }
          break;
        default:
          returnVal = false;
          break;
      }
      return returnVal;
    },

    getvinLineLoadOrCtText(item) {
      if (this.storeState.alarmTypes.find(t => t.value === item.type).vinApplicable) {
        return `Vin ${item.vinLineLoadOrCt + 1}`;
      }
      if (this.storeState.alarmTypes.find(t => t.value === item.type).loadApplicable) {
        if (this.storeState.data.loads.length === 0) {
          return `Load ${item.vinLineLoadOrCt + 1}`;
        }
        return `Load ${item.vinLineLoadOrCt + 1} - ${this.storeState.data.loads[item.vinLineLoadOrCt].name}`;
      }
      if (this.storeState.alarmTypes.find(t => t.value === item.type).ctApplicable) {
        return `CT ${item.vinLineLoadOrCt + 1}`;
      }
      if (this.storeState.alarmTypes.find(t => t.value === item.type).lineApplicable) {
        if (item.vinLineLoadOrCt > 2) {
          return `Vin 2 - Line ${item.vinLineLoadOrCt - 2}`;
        }
        return `Vin 1 - Line ${item.vinLineLoadOrCt + 1}`;
      }
      return '#NA';
    },

    descriptionFormatter(text, textWarning) {
      let alarmResult;
      if (this.editedItem.led) {
        if (this.editedItem.relay) {
          alarmResult = 'Both the LED and the Relay will be triggered when this alarm is active.';
        } else {
          alarmResult = 'The LED will be triggered when this alarm is active.';
        }
      } else if (this.editedItem.relay) {
        alarmResult = 'The Relay will be triggered when this alarm is active.';
      } else {
        alarmResult = 'Neither the LED nor the Relay will be triggered when this alarm is active.';
      }
      const this2 = this;
      const parseArgs = function (text_) {
        return text_
          .split('{SetPoint}')
          .join((this2.editedItem.setPoint === 0 || this2.editedItem.setPoint === '') ? 'the Set Point' : this2.editedItem.setPoint + this2.editedItem.unit)
          .split('{Delay}')
          .join((this2.editedItem.delay === '') ? 'the Delay' : (this2.editedItem.delay === 1 ? 'the delay of 1 second' : `the delay of ${this2.editedItem.delay} seconds`)) // eslint-disable-line no-nested-ternary
          .split('{DelayTime}')
          .join((this2.editedItem.delay === '') ? '0 seconds' : (this2.editedItem.delay === 1 ? '1 second' : `${this2.editedItem.delay} seconds`)) // eslint-disable-line no-nested-ternary
          .split('{Vin}')
          .join((this2.editedItem.vinLineLoadOrCt === -1 || this2.editedItem.vinLineLoadOrCt === '') ? 'the Vin' : `Vin ${this2.editedItem.vinLineLoadOrCt + 1}`)
          .split('{Line}')
          .join((this2.editedItem.vinLineLoadOrCt === -1 || this2.editedItem.vinLineLoadOrCt === '') ? 'the Line' : (this2.editedItem.vinLineLoadOrCt > 2) ? `Line ${this2.editedItem.vinLineLoadOrCt - 2}` : `Line ${this2.editedItem.vinLineLoadOrCt + 1}`)
          .split('{LineVin}')
          .join((this2.editedItem.vinLineLoadOrCt === -1 || this2.editedItem.vinLineLoadOrCt === '') ? 'the Vin' : `Vin ${Math.floor(this2.editedItem.vinLineLoadOrCt / 3) + 1}`)
          .split('{Load}')
          .join((this2.editedItem.vinLineLoadOrCt === -1 || this2.editedItem.vinLineLoadOrCt === '') ? 'the Load' : `Load ${this2.editedItem.vinLineLoadOrCt + 1}`)
          .split('{Ct}')
          .join((this2.editedItem.vinLineLoadOrCt === -1 || this2.editedItem.vinLineLoadOrCt === '') ? 'the CT' : `CT ${this2.editedItem.vinLineLoadOrCt + 1}`)
          .split('{AlarmResult}')
          .join(alarmResult)
          .split('{SetPointMinusDeadband}')
          .join((this2.editedItem.setPoint - this2.editedItem.deadband) + this2.editedItem.unit)
          .split('{SetPointPlusDeadband}')
          .join((this2.editedItem.setPoint + this2.editedItem.deadband) + this2.editedItem.unit);
      };
      if (textWarning !== undefined) {
        textWarning = parseArgs(textWarning);

        text = parseArgs(text)
          .split('{Warning}')
          .join(textWarning);
      }
      let returnValue = parseArgs(text);
      /*
      if (returnValue.includes('{LoadMinCtLoad}') || returnValue.includes('{LoadMmaxCtLoad}')) {
        if (this.editedItem.vinLineLoadOrCt == -1) {
          returnValue = returnValue.split('{LoadMinCtLoad}')
                          .join('the minimum rated current of the CTs');
          returnValue = returnValue.split('{LoadMaxCtLoad}')
                          .join('the maximum rated current of the CTs');
        } else {
          var cts = '';
          var maxRatedCurrent = -1;
          var minRatedCurrent = -1;
          this.storeState.data.loads[this.editedItem.vinLineLoadOrCt].cts.forEach((ct) => {
            if (!ct.active) {
              return;
            }
            if (cts !== '') {
              cts += '/';
            }
            var ctMaxCurrent = this.storeState.ctTypes[ct.type].maxCurrent;
            if (ctMaxCurrent === null) {
              ctMaxCurrent = ct.maxRating;
            }
            if (maxRatedCurrent === -1) {
              maxRatedCurrent = ctMaxCurrent;
            } else {
              maxRatedCurrent = Math.max(maxRatedCurrent, ctMaxCurrent);
            }
            if (minRatedCurrent === -1) {
              minRatedCurrent = ctMaxCurrent;
            } else {
              minRatedCurrent = Math.min(minRatedCurrent, ctMaxCurrent);
            }
            cts += `CT${ct.channel - 5}`;
          });
          returnValue = returnValue.split('{LoadMinCtLoad}')
                          .join(`the minimum rated current of ${cts} = ${minRatedCurrent} A`);
          returnValue = returnValue.split('{LoadMaxCtLoad}')
                          .join(`the minimum rated current of ${cts} = ${maxRatedCurrent} A`);
        }
      }
      */
      if (returnValue.includes('{LoadCts}')) {
        if (this.editedItem.vinLineLoadOrCt === -1) {
          returnValue = returnValue.split('{LoadCts}').join('the Load CTs');
        } else {
          let cts = '';
          this.storeState.data.loads[this.editedItem.vinLineLoadOrCt].cts.forEach((ct) => {
            if (!ct.active) {
              return;
            }
            if (cts !== '') {
              cts += ',';
            }
            cts += `CT${ct.channel - 5}`;
          });
          returnValue = returnValue.split('{LoadCts}').join(cts);
        }
      }
      if (returnValue.includes('{CtMaxValue}')) {
        if (this.editedItem.vinLineLoadOrCt === -1) {
          returnValue = returnValue.split('{CtMaxValue}').join('its max rated current');
        } else {
          const t = this.storeState.data.allCts[this.editedItem.vinLineLoadOrCt].type;
          let c = this.storeState.ctTypes[t].maxCurrent;
          if (c === null) {
            c = this.storeState.data.allCts[this.editedItem.vinLineLoadOrCt].maxRating;
          }
          returnValue = returnValue.split('{CtMaxValue}').join(`its max rated current of ${c}A`);
        }
      }
      if (returnValue.includes('{CtMaxValueMinusDeadband}')) {
        if (this.editedItem.vinLineLoadOrCt === -1) {
          returnValue = returnValue.split('{CtMaxValueMinusDeadband}').join('its max rated current minus the deadband');
        } else {
          const t = this.storeState.data.allCts[this.editedItem.vinLineLoadOrCt].type;
          let c = this.storeState.ctTypes[t].maxCurrent;
          if (c === null) {
            c = this.storeState.data.allCts[this.editedItem.vinLineLoadOrCt].maxRating;
          }
          c -= this2.editedItem.deadband;
          returnValue = returnValue.split('{CtMaxValueMinusDeadband}').join(`${c}A`);
        }
      }
      if (returnValue.includes('{LineExpectedVoltage}') || returnValue.includes('{LineExpectedVoltageCalculation}')) {
        if (this.editedItem.vinLineLoadOrCt === -1) {
          returnValue = returnValue.split('{LineExpectedVoltage}').join('the Line\'s expected voltage');
        } else {
          const vin = Math.floor(this.editedItem.vinLineLoadOrCt / 3);
          const ct = (this.editedItem.vinLineLoadOrCt > 2) ? (this.editedItem.vinLineLoadOrCt - 2) : (this.editedItem.vinLineLoadOrCt + 1);
          returnValue = returnValue.split('{LineExpectedVoltage}').join(`Line ${ct}'s expected voltage of ${this.storeState.data.inputs[vin].voltage}V`);
        }
      }

      return returnValue;
    },
  },
  timers: {
    forceMappingComplete: { time: 5000, repeat: false, autostart: false },
  },

};
</script>

<style>
  .notApplicable.v-input>.v-input__control>.v-input__slot>.v-text-field__slot>input {
    color: #999999 !important;
  }
  .textFieldAsLabel.v-input>.v-input__control>.v-input__slot:before {
      border-style: none !important;
  }
  .textFieldAsLabel.v-input>.v-input__control>.v-input__slot:after {
      border-style: none !important;
  }
  .disabledCheckbox.v-input>.v-input__control>.v-input__slot>.v-input--selection-controls__input {
      color: #666666 !important
  }
</style>
